import React, {useState} from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import {notifyUser} from "../../../util/util";
import {serverRequest} from "../../../util/server_request";
import {Spin} from "antd";

export const OneTimePinFP = () => {
    const navigate = useNavigate();
    const location = useLocation();
   
    const rawPhone = location.state?.phone;
    // For display: 0XXXXXXXXX
    const phone = rawPhone && rawPhone.startsWith('233') && rawPhone.length === 12
        ? '0' + rawPhone.slice(3)
        : rawPhone;

    // Mask phone number for display (e.g., 05****8725)
    const maskPhone = (phone) => {
        if (!phone || phone.length < 6) return phone;
        return phone.slice(0, 2) + '****' + phone.slice(-4);
    };
    const maskedPhone = maskPhone(phone);

    const [otp, setOTP] = useState('')
    const [loading, setLoading] = useState(false)

    const toggleLoading = () => setLoading(prevState => !prevState)

    const changeHandler = (e) => setOTP(e.target.value)

    const verifyOTP = () => {
        if (otp === '' || otp === null){
            return notifyUser('error', 'Please enter OTP received to proceed!', 'Validation Error');
        }
        toggleLoading()
        serverRequest('GET', `auth/verify/phone/otp?otp=${otp}&phone=${phone}`)
            .then(result =>{
                toggleLoading()
                if (!result?.success){
                    notifyUser('error', result?.message, 'Error')
                }else{
                    navigate('/forgot-password/verify-account-pin', {state: {phone, otp}})
                }
            }).catch(error => {
            toggleLoading()
            notifyUser('error', error, 'Error')
        })
    }

    const rerTriggerOTP = (phoneNumber) => {
        toggleLoading()
        serverRequest('POST', 'auth/phone-verification/otp/send', {phone: phoneNumber})
            .then(result => {
                toggleLoading()
                if (result?.code === '400'){
                    notifyUser('success', result.message, 'OTP')
                }else{
                    notifyUser('success', `OTP sent to ${phoneNumber}`, 'OTP')
                }
            }).catch(error => {
            toggleLoading()
            notifyUser('error', error, 'Validation Error')
        })
    }


    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Enter your One Time Pin</p>
                <small className='text-center'>We've sent a One-Time Pin(OTP) to this number <strong>{maskedPhone}</strong>.</small>

                <Spin spinning={loading}>
                    <div className="mt-4 w-75 mx-auto mobile-full-width">
                        <omk-otp-field
                            number-of-inputs="6"
                            resend-text=""
                            resend-button-label=""
                            label="One-time Password"
                            className='mb-2' value={otp} onInput={changeHandler} />
                        <p className='mb-0' style={{cursor: 'pointer', paddingBottom: '10px'}} onClick={() => rerTriggerOTP(phone)}>Didn't receive OTP? <span style={{color: '#009677', fontWeight: 'bold'}}>Resend</span></p>


                        <p className="text-center omk-text-small text-black-50 mb-5"><i className="bi bi-shield-lock"/> Your information is confidential and secure</p>
                        <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={verifyOTP}>Continue</button>
                        <p className="text-center mt-3">
                            <a href="/onboard/login" className="fw-bold text-decoration-underline" style={{ color: '#009677' }}>
                                Back to Login
                            </a>
                        </p>
                    </div>
                </Spin>
            </div>
        </div>
    )
}